export default __webpack_public_path__ + "static/media/AtomsAndCompounds _11.13cfb724.png";